// extracted by mini-css-extract-plugin
export default {"profileTabsContainer":"profile-page_profileTabsContainer__ygFrD","profileNotificationSettingsContainer":"profile-page_profileNotificationSettingsContainer__4Gq5y"};